import { combineReducers } from 'redux'
import { reducer as generalReducer } from './general'
import { reducer as dataReducer } from './data'
import { reducer as goalShowReducer } from './goal-show'

export const reducer = combineReducers({
  general: generalReducer,
  data: dataReducer,
  goalShow: goalShowReducer
})
